import React from 'react'
import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  root: {
    fontFamily: 'Dazzed',
    fontWeight: 500,
    fontSize: 10,
    lineHeight: '18px',
    color: 'var(--text-color-6)'
  },
  bold: {
    fontWeight: '600 !important'
  },
  thin: {
    fontWeight: '400 !important'
  }
}))

const DazzedParagraph10 = ({ children, className, thickness = 'normal', onClick, textAlign }) => {
  const classes = useStyles()

  return (
    <div
      style={textAlign ? { textAlign } : {}}
      className={[
        classes.root,
        thickness === 'bold' && classes.bold,
        thickness === 'thin' && classes.thin,
        className
      ].join(' ')}
      onClick={onClick}
    >
      {children}
    </div>
  )
}

export default DazzedParagraph10
